import { Api } from "../Api";
import { ISystem } from "../models/ISystem";

class SystemApi {
  static list(signal?: AbortSignal): Promise<ISystem[]> {
    return Api.Get<ISystem[]>("api/systems", signal);
  }

  static listAdmin(signal?: AbortSignal): Promise<ISystem[]> {
    return Api.Get<ISystem[]>("api/systems/admin", signal);
  }

  static get(uuid: string, signal?: AbortSignal): Promise<ISystem> {
    return Api.Get<ISystem>(`api/system/${uuid}`, signal);
  }

  static create(system: ISystem, signal?: AbortSignal): Promise<ISystem>{
    return Api.Post<ISystem>(`api/system`, system, signal);
  }  

  static update(uuid: string, system: ISystem, signal?: AbortSignal): Promise<ISystem>{
    return Api.Put<ISystem>(`api/system/${uuid}`, system, signal);
  }

  static delete(uuid: string, signal?: AbortSignal): Promise<ISystem> {
    return Api.Delete<ISystem>(`api/system/${uuid}`, signal);
  }

  static activateSystem(uuid: string, signal?: AbortSignal): Promise<ISystem>{
    return Api.Post<ISystem>(`api/system/activate/${uuid}`,signal);
  }

  static deactivateSystem(uuid: string, signal?: AbortSignal): Promise<ISystem>{
    return Api.Post<ISystem>(`api/system/deactivate/${uuid}`, signal);
  }
}

export { SystemApi }
